export default __webpack_public_path__ + "static/media/8200-series-Hydrocarbon-Trap.b0280742.jpg";